import styled from "@emotion/styled"
import { Button } from "@mui/material"
import dynamic from "next/dynamic"
import Link from "next/link"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import { LARGE_DESKTOP_CONT_WIDTH } from "pazChargeComponents/Home/HomePageCharge"
import animationData from 'public/animation/arrow.json'
import { trackEventName } from "reusable/ChargeGTM"
import colors from "theme/colors"
import { Container, Desktop, ImageContainer, Mobile, NewText, TitleWithLine, extractProperty } from "ui"
import { sharedColors } from "ui/theme/colors"
import { getNonUmbracoURL } from "utils/utils"

// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const StyledBodyWrapper = styled.div`
flex: 1;
h4 {
    color: ${colors.blue};
     margin: 0px;
}
 p {
 margin-top: 10px;
}
> p {
    margin-top: 30px;
}
padding-bottom: 50px;
${(props) => props.theme.breakpoints.up("md")} {
    padding: 20px;
    padding-left: 0px;
 }
`

const StyledWrapper = styled.div`
display: flex;
flex-direction: column;
padding-bottom: 30px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 50px;
 }
${(props) => props.theme.breakpoints.up("lg")} {
   flex-direction: row;
}
`
const StyledImage = styled.div`
${(props) => props.theme.breakpoints.up("lg")} {
   width: 675px;
}
`
const StyledLink = styled(Link)`
    text-decoration: none;
`
const StyledButton = styled(Button)`
    height: 45px;
    width: 261px;
  border-radius: 24px;
  opacity: 0px;
  background-color: ${sharedColors.blue};
  gap: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
   :hover {
    background-color:  ${sharedColors.blue};
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    height: 45px;
    width: 261px;
    height: 40px;
    border-radius: 40px;
  }
`
const StyledLottieWrapper = styled.div`
    width: 18px;
    // height: 30px;
    color: white;
`
type Props = {
    data: any
}
function VehivcleFleetsImageAndText({ data }: Props) {
    const headline = extractProperty(data, "headline")
    const image = extractProperty(data, "image")
    const body = extractProperty(data, "body")
    const mobileImage = extractProperty(data, "mobileImage")
    const button = extractProperty(data, "button")

    const handleExtraInfoButtonClicked = () => {
        trackEventName("paz_charge_more_info")
    }
    return (
        <>
            <Mobile>
                <ImageContainer
                    desktopUrl={getNonUmbracoURL(image)}
                    mobileUrl={getNonUmbracoURL(mobileImage)}
                    height={554}
                    mediumHeight={335}
                    mobileHeight={285}
                />
            </Mobile>
            <ContainerWrapper>
                <StyledWrapper>
                    <StyledBodyWrapper>
                        <TitleWithLine
                            component={"h2"}
                            largeDesktopFontSize={34}
                            largeDesktopLineHeight="36px"
                            titleFontSize={34}
                            desktopLineHeight={"36px"}
                            mobileTitleFontSize={24}
                            mobileLineHeight={"28px"}
                            desktopFontWeight={500}
                            title={headline}
                            titleColor={colors.black}
                        />
                        <NewText
                            component={"p"}
                            largeDesktopFontSize={18}
                            largeDesktopLineHeight="20px"
                            desktopFontSize={18}
                            desktopLineHeight={"20px"}
                            desktopFontWeight={400}
                            mobileFontSize={16}
                            mobileLineHeight={"18px"}
                            mobileFontWeight={400}
                            dangerouslySetInnerHTML={{ __html: body }}

                        >
                        </NewText>
                            <StyledButton
                                variant="contained"
                                href={getNonUmbracoURL(button[0].url)}
                                 aria-label={button[0].name} 
                                 onClick={handleExtraInfoButtonClicked} 
                            >
                                <NewText
                                    component={"div"}
                                    desktopFontSize={16}
                                    desktopLineHeight={"24px"}
                                    mobileFontSize={16}
                                    mobileLineHeight={"24px"}
                                    color="white"
                                >
                                    {button[0].name}
                                </NewText>
                                <StyledLottieWrapper style={{ filter: 'invert(1) brightness(1000%)' }}>
                                    <Lottie animationData={animationData} loop={true} color="white" />
                                </StyledLottieWrapper>
                            </StyledButton>
                    </StyledBodyWrapper>
                    <StyledImage>
                        <Desktop>
                            <ImageContainer
                                desktopUrl={getNonUmbracoURL(image)}
                                mobileUrl={getNonUmbracoURL(mobileImage)}
                                height={554}
                                mediumHeight={335}
                                mobileHeight={285}
                                fill
                            />
                        </Desktop>
                    </StyledImage>
                </StyledWrapper>
            </ContainerWrapper>
        </>
    );
}

export default VehivcleFleetsImageAndText;
